{
	"populer": "Popüler",
	"buy": "Sepete Ekle",
	"detail": "Detaylar",
	"no-stock": "Tükendi",
	"optional": "Günlük",
	"close": "Kapat",
	"speaker": "Konuşmacılar",
	"modalSpeakerTitle": "Konuşmacı",
	"speakerDetail": "Konuşmacı Detayı",
	"program": "Program",
	"photoAlbum": "Fotoğraf Albümü",
	"showAll": "Tümünü Göster",
	"selectedSession": "Seçili Oturumlar",
	"searchSpeakersSession": "Oturumlarda & Konuşmacı ara...",
	"searchSpeaker": "Konuşmacı Arama...",
	"notFoundSpeaker": "Aradığınız kriterlerde uygun kişi bulunamadı!",
	"cart": "Sepet",
	"price": "Fiyat",
	"quantity": "Adet",
	"total": "Toplam: ",
	"goToCart": "Sepete Git",
	"emptyCart": "Sepetiniz Boş",
	"free": "Ücretsiz",
	"modalSessionTitle": "Oturum",
	"programNotFound": "Program henüz eklenmemiş veya etkinlik aktif edilmemiş!",
	"photoAlbumNotFound": "Fotoğraf albümü bulunamadı!",
	"faq": "Sıkça Sorulan Sorular",
	"areaMaps": "Alan Haritaları",
	"areaMapsNotFound": "Alan haritası bulunamadı!",
	"enlarge": "Büyüt",
	"my-ticket": "Biletlerim",
	"brand-description-title": "Kapital Media Group",
	"brand-description": "Provided by",
	"cart_items_count_not_within_limit": "Bu formun minimum {min} bilet zorunluluğu vardır.",
	"cart_items_count_not_within_limit_with_max": "Bu formun minimum {min}, maksimum {max} bilet zorunluluğu vardır.",
	"share": "Paylaş",
	"decrease-quantity": "Adedi azalt",
	"increase-quantity": "Adedi artır",
	"remove-item": "Ürünü sepetten kaldır",
	"copy-link": "Bağlantıyı kopyala",
	"link-copied": "Bağlantı kopyalandı",
	"share-email": "E-posta",
	"sessionCount": "{count} oturum",
	"speakerCount": "{count} konuşmacı",
	"sessionNotFound": "Aradığınız kriterlere uygun oturum bulunamadı.",
	"liveNow": "Şu an",
	"biography": "Hakkında",
	"speakerSessions": "Oturumları",
	"sponsor": "Sponsor",
	"sessionDate": "Tarih",
	"sessionTime": "Saat",
	"sessionHall": "Salon",
	"sessionAbout": "Oturum Hakkında",
	"eventDescription": "Etkinlik Hakkında",
	"showMore": "Devamını oku",
	"showLess": "Daha az göster"
}
